import { axios, authClient } from '@/main';
import store from '@/store';
import REQUEST_UPDATE_PAYMENT_INFO from '@/graphql/Billing/requestUpdatePaymentInfo.gql';

export default class BillingResource {
    async get () {
        return await axios.get(process.env.VUE_APP_REST_API + `billing_plans`)
    }

    async checkPlan (id) {
        return await axios.get(process.env.VUE_APP_REST_API + `billing_settings/plan_check?plan_id=${id}`)
    }

    async getPlanApplyings (id) {
        return await axios.get(process.env.VUE_APP_REST_API + `billing_settings/allowed_plan_applyings?plan_id=${id}`)
    }

    async requestUpdatePaymentInfo(desirePaymentMethod) {
        return await authClient.query({
            query: REQUEST_UPDATE_PAYMENT_INFO,
            variables: {
                desire_payment_method: desirePaymentMethod
            },
            update: data => data.requestUpdatePaymentInfo
        })
    }

    async getPaymentMethods () {
        return await axios.get(process.env.VUE_APP_REST_API + `billing_settings/payment_methods`)
    }

    async set () {
        return await axios.post(process.env.VUE_APP_REST_API + `subscriptions/request`, {
            plan_id: store.getters.getBillingInfo.planId,
            provider_method: store.getters.getBillingInfo.method,
            billing_address: {
                country: {
                    code: store.getters.getBillingInfo.country.code,
                    continent_code: store.getters.getBillingInfo.country.continent_code,
                    name: store.getters.getBillingInfo.country.name,
                    iso3: store.getters.getBillingInfo.country.iso3,
                    number: store.getters.getBillingInfo.country.number,
                    full_name: store.getters.getBillingInfo.country.full_name,
                    tax_id_required: store.getters.getBillingInfo.country.tax_id_required ? 1 : 0,
                    created_at: store.getters.getBillingInfo.country.created_at,
                    updated_at: store.getters.getBillingInfo.country.updated_at,
                    payment_provider_id: store.getters.getBillingInfo.country.payment_provider_id,
                    currency: store.getters.getBillingInfo.country.currency,
                },
                state: store.getters.getBillingInfo.address[0],
                city: store.getters.getBillingInfo.address[1],
                street: store.getters.getBillingInfo.address[2],
                house_number: store.getters.getBillingInfo.houseNumber,
                zip: store.getters.getBillingInfo.address[3],
                tax_id: store.getters.getBillingInfo.address[4],
                no_tax_id: store.getters.getBillingInfo.noTax,
                company: store.getters.getBillingInfo.address[5],
                country_code: store.getters.getBillingInfo.address[6]
            },
            plan_applying: store.getters.getBillingInfo.planApplying
        })
    }

    async reactivate () {
        return await axios.post(process.env.VUE_APP_REST_API + `subscriptions/reactivate`)
    }
}
